import React from 'react';
import ChatBadge from './chatBadge';

import EmptyImage from '../../../../../../assets/image/shared/chat_empty_profile_image.svg';

interface ChatUserImageProps {
  is_online: boolean;
  image: string | null;
}
const ChatUserImage = ({is_online, image}: ChatUserImageProps) => {
  return (
    <div className="flex  relative items-center">
      <div className="flex min-w-[56px] h-[56px]">
        <img
          loading="lazy"
          className="rounded-full"
          src={image ? image : EmptyImage}
          width={56}
          height={56}
          alt=""
        />
      </div>
      {is_online && <ChatBadge color="bg-red-700" />}
    </div>
  );
};

export default ChatUserImage;
